import React from "react";

import { TablePagination } from "@mui/material";

import "./styles.scss";
import { PaginationProps } from "./types";

const classNameBase = "scd-table-pagination";

export default function Pagination(props: PaginationProps): React.ReactElement {
  return (
    <tfoot>
      <tr>
        <TablePagination
          classes={{
            root: `${classNameBase}-root`,
            toolbar: `${classNameBase}-toolbar`,
            spacer: `${classNameBase}-spacer`,
            selectRoot: `${classNameBase}-select-root`,
            select: `${classNameBase}-selected`,
            selectIcon: `${classNameBase}-selection-icon`,
            input: `${classNameBase}-input`,
            menuItem: `${classNameBase}-menu-item`,
            actions: `${classNameBase}-actions`,
          }}
          count={props.count}
          onPageChange={props.onChangePage}
          page={props.page}
          rowsPerPage={props.rowsPerPage}
          rowsPerPageOptions={props.rowsPerPageOptions}
        />
      </tr>
    </tfoot>
  );
}
